const footerColumns = [
  {
    title: '内容分区',
    links: [
      { label: '热门榜', href: '#top-chart' },
      { label: '必看清单', href: '#must-read' },
      { label: '高能盘点', href: '#roundup' },
      { label: '爆款合集', href: '#collections' },
    ],
  },
  {
    title: '快速入口',
    links: [
      { label: 'TOP榜', href: '#top-chart' },
      { label: '精华推荐', href: '#index' },
      { label: '合集索引', href: '#index' },
      { label: '常见问答', href: '#faq' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200 mt-16 md:mt-24">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr] gap-9 md:gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-base">
                <i className="ri-fire-line" />
              </span>
              <span className="font-heading font-bold text-foreground-950 text-lg">黑料大全</span>
            </div>
            <p className="mt-4 max-w-md text-foreground-700 text-sm leading-relaxed">
              黑料大全精华榜单聚合热门榜、必看清单与高能盘点，爆款合集按热度排序。从 TOP榜入口直接挑最炸的料，高效浏览不踩空。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['热门榜', '精华推荐', '必看清单', '高能盘点', '爆款合集', 'TOP榜'].map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded-full bg-background-50 border border-secondary-200 text-foreground-700 text-xs font-label"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading font-semibold text-foreground-950 text-base">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-foreground-700 text-sm hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-foreground-600 text-xs">© 2026 黑料大全 · 内容均为公开信息的整理与归档</p>
          <div className="flex items-center gap-4">
            <a href="#top" className="text-foreground-600 text-xs hover:text-primary-600 transition-colors cursor-pointer">
              返回顶部
            </a>
            <a href="#faq" className="text-foreground-600 text-xs hover:text-primary-600 transition-colors cursor-pointer">
              常见问答
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}